import React, { useEffect, useMemo } from 'react';
import { Button, Col, Input, Row, Label, ModalBody, Form, Spinner, FormFeedback, FormGroup, Nav, NavItem, NavLink, TabContent, TabPane, ModalFooter, Alert } from 'reactstrap';
import classnames from 'classnames';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { addNewPowerGenerationMaintenance, getPowerGenerationMaintenanceList, updatePowerGenerationMaintenance } from '../../../../slices/thunks';
import { ODataGrid } from '../../../../Components/OElements/ODataGrid';
import { DatePickerInput, DatesProvider } from '@mantine/dates';


const PowerGenerationSourceMaintenanceForm = ({ dataPowerGenerationSource, isEdit, handleToggleModal, isOpen }) => {
	const dispatch = useDispatch();


	const selector = createSelector(
		state => state.PowerGenerationMaintenance,
		data => ({
			list: data.itemPowerGenerationMaintenanceList,
			isLoadingList: data.isLoadingList,
			isPowerGenerationSourceSuccess: data.isPowerGenerationSourceSuccess,
			isAdding: data.isAdding,
			isUpdating: data.isUpdating,
			requireCloseModal: data.requireCloseModal,
		})
	);

	const { list, isLoadingList, isAdding, isUpdating, requireCloseModal } = useSelector(selector);

	useEffect(() => {
		dispatch(getPowerGenerationMaintenanceList({ id: dataPowerGenerationSource._id }));
	}, [dataPowerGenerationSource]);


	const validation = useFormik({
		enableReinitialize: true,
		initialValues: {
			date_ini: dataPowerGenerationSource.date_ini || '',
			date_end: dataPowerGenerationSource.date_end || '',
			observation: dataPowerGenerationSource.observation || ''
		},
		validationSchema: Yup.object({
			date_ini: Yup.string().required('Campo requerido'),
			date_end: Yup.string().required('Campo requerido'),
			observation: Yup.string().nullable(),
		}),
		onSubmit: values => {
			const data = {
				hour_meter: dataPowerGenerationSource.hour_meter,
				feeding_barges_id: dataPowerGenerationSource.feeding_barges_id,
				power_generation_source_id: dataPowerGenerationSource._id,
				observation: values.observation,
				date_ini: values.date_ini,
				date_end: values.date_end
			};

			console.log(data);

			if (isEdit) {
				data._id = dataPowerGenerationSource._id;
				dispatch(updatePowerGenerationMaintenance(data));
			} else {
				dispatch(addNewPowerGenerationMaintenance(data));
			}
		},
	});


	const columns = useMemo(
		() => [
			{ header: 'Fuente', accessorKey: 'power_generation_source.name', width: '5%' },
			{ header: 'Número Serie', accessorKey: 'power_generation_source.serial_number', width: '5%' },
			{ header: 'Horómetro', accessorKey: 'hour_meter', dataType: 'separator', width: '5%' },
			{ header: 'Fecha Inicio', accessorKey: 'date_ini', dataType: 'date', width: '5%' },
			{ header: 'Fecha Término', accessorKey: 'date_end', dataType: 'date', width: '5%' },
			{ header: 'Observación', accessorKey: 'observation', width: '50%' },
		],
	);




	return (
		<React.Fragment>
			<ModalBody className='modal-body'>
				<Form onSubmit={e => {
					e.preventDefault();
					if (Object.keys(validation.errors).length != 0) { toast.error('Por favor, revisa la información ingresada. Hemos encontrado algunos detalles que necesitan corrección antes de continuar.', { autoClose: 4000 }); }
					validation.handleSubmit();
					return false;
				}}>

					<Row className='g-3'>

						<Col lg={3}>
							<Label for='name' className='form-label'>Nombre</Label>
							<Input name='name' id='name' type='text' disabled='true' value={dataPowerGenerationSource?.name} />
						</Col>

						<Col lg={3}>
							<Label for='hour_meter' className='form-label'>Horómetro</Label>
							<Input name='hour_meter' id='hour_meter' type='text' disabled='true' value={dataPowerGenerationSource?.hour_meter} />
						</Col>

						<Col lg={3}>
							<Label for='feeding_barges' className='form-label'>Artefacto Naval</Label>
							<Input name='feeding_barges' id='feeding_barges' type='text' disabled='true' value={dataPowerGenerationSource?.feeding_barges?.name} />
						</Col>

						<Col lg={3}>
							<Label for='power_generation_type' className='form-label'>Tipo</Label>
							<Input name='power_generation_type' id='power_generation_type' type='text' disabled='true' value={dataPowerGenerationSource?.power_generation_type?.name} />
						</Col>

						<Col lg={3}>
							<Label for='fuel_type' className='form-label'>Tipo Combustible</Label>
							<Input name='fuel_type' id='fuel_type' type='text' disabled='true' value={dataPowerGenerationSource?.fuel_type?.name} />
						</Col>

						<Col lg={3}>
							<Label for='serial_number' className='form-label'>Número de Serie</Label>
							<Input name='serial_number' id='serial_number' type='text' disabled='true' value={dataPowerGenerationSource?.serial_number} />
						</Col>
						<Col sm={3}>
							<DatesProvider settings={{ locale: 'es-mx', firstDayOfWeek: 1, weekendDays: [0], timezone: 'UTC' }}>
								<DatePickerInput
									label='Fecha Inicio'
									id='date_ini'
									name='date_ini'
									placeholder="Seleccione una fecha"
									value={validation.values.date_ini || new Date()} // Set default value to today
									onChange={(date) => {
										validation.setFieldValue("date_ini", date);
									}}
									onBlur={validation.handleBlur}
									valueFormat='DD-MM-YYYY'
									minDate={new Date()}
									error={
										validation.touched['date_ini'] && validation.errors['date_ini']
											? validation.errors['date_ini']
											: ''
									}
									clearable={true}
								/>
							</DatesProvider>
						</Col>

						<Col sm={3}>
							<DatesProvider settings={{ locale: 'es-mx', firstDayOfWeek: 1, weekendDays: [0], timezone: 'UTC' }}>
								<DatePickerInput
									label='Fecha Término'
									id='date_end'
									name='date_end'
									placeholder="Seleccione una fecha"
									value={validation.values.date_end || new Date()} // Set default value to today
									onChange={(date) => {
										validation.setFieldValue("date_end", date);
									}}
									onBlur={validation.handleBlur}
									valueFormat='DD-MM-YYYY'
									minDate={new Date()}
									error={
										validation.touched['date_end'] && validation.errors['date_end']
											? validation.errors['date_end']
											: ''
									}
									clearable={true}
								/>
							</DatesProvider>
						</Col>




						<Col lg={12}>
							<Label for='observation' className='form-label'>Observación</Label>
							<Input name='observation' id='observation' type='textarea' placeholder='Ingrese una observación' {...validation.getFieldProps('observation')} invalid={!!validation.errors.observation && validation.touched.observation} />
							<FormFeedback>{validation.errors.observation}</FormFeedback>
						</Col>

					</Row>


					<div className='modal-footer mt-2 p-0'>
						<Button type='button' onClick={handleToggleModal} className='btn-danger btn-label'>
							<i className="icon-x label-icon"></i>Cancelar
						</Button>
						<button type='submit' className='btn btn-label btn-primary' id='add-btn' disabled={isAdding || isUpdating}>
							{isAdding || isUpdating ? (<i className='label-icon'><Spinner size='sm' /></i>) : (<i className='ri-save-3-line label-icon'></i>)}
							{isEdit ? 'Editar' : 'Agendar'} Mantención
						</button>
					</div>
				</Form>
			</ModalBody>
			<ModalFooter>
				<ODataGrid columns={columns} data={list || []} />
			</ModalFooter>
		</React.Fragment>
	);
};

export default PowerGenerationSourceMaintenanceForm;
